import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const NavItem = forwardRef((props, ref) => {
	const { className, children, active, ...otherProps } = props;
	const itemClass = classNames(
		'flex flex-between ws-nowrap flex-start px-0--xs pb-4 pb-2--xs c-secondary-500 c-pointer fw-500',
		{
			bb: active,
			'bc-secondary-500': active,
			'bw-4': active,
			// 'c-secondary-600': active
		},
		className
	);

	return (
		<li ref={ref} {...otherProps} className={itemClass}>
			{children}
		</li>
	);
});

NavItem.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	active: PropTypes.bool,
	onClick: PropTypes.func,
};

NavItem.defaultProps = {
	className: '',
	active: false,
	onClick: () => {},
};

NavItem.displayName = 'NavItem';

export default NavItem;
